<template>
  <div class="payment-result-area">
    <div class="payment-result-card">
      <div class="result-icon cancel">
        <i class="ti ti-x"></i>
      </div>
      <h1>Payment Cancelled</h1>
      <p>Your payment was cancelled and you have not been charged. You can try again whenever you're ready.</p>

      <div class="result-actions">
        <RouterLink to="/#pricing" class="btn">
          <span class="border-style">View Pricing Plans</span>
        </RouterLink>
        <RouterLink to="/" class="result-secondary-link">Back to Home</RouterLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PaymentCancelPage",
});
</script>

<style scoped>
.payment-result-area {
  min-height: 100vh;
  background: #0a0102;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}
.payment-result-card {
  background: #201516;
  border: 1px solid #3a2526;
  border-radius: 20px;
  padding: 3rem 2.5rem;
  max-width: 480px;
  width: 100%;
  text-align: center;
}
.result-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2.5rem;
}
.result-icon.cancel {
  background: rgba(201, 14, 14, 0.15);
  color: #f87171;
}
h1 {
  color: #fff;
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 1rem;
}
p {
  color: #c0c0c0;
  line-height: 1.65;
  margin-bottom: 1.75rem;
}
.result-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
}
.result-secondary-link {
  color: #c0c0c0;
  font-size: 0.9rem;
  text-decoration: none;
}
.result-secondary-link:hover { color: #fff; }
</style>
